import { useFormik } from "formik";
import { useState, ChangeEvent } from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setSamithi_MembersMessage } from "redux/actions";
import { useNavigate } from "react-router";


import { useAppDispatch } from "redux/store";
import { addSamithi_Members, updateSamithi_Members } from "services/samithi_membersService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
import vibhag from "../../data/vibhag.json";
import jillas from "../../data/jilla.json";
import nagars from "../../data/nagar.json";
import upamandal from "../../data/upamandal.json";
import basti from "../../data/basti.json";
import gramam from "../../data/gramam.json";
import rev_zillas from "../../data/districts.json";
import occupation from "../../data/occupation.json";
import bhadyatha from "../../data/bhadyatha.json";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { validateAdditionalItems } from "ajv/dist/vocabularies/applicator/additionalItems";

const ViewMembersButton = styled(Button)`
  @media (max-width: 576px) {
    span.text {
      display: none;
    }
  }`;


const generalStyles = {
    marginTop: '2%'
}

type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const Samithi_MembersForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isPreview, setIsPreview] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const iValue = { samithi_member_id: 0, name: '', surname: '', father_name: '',
     age: '', occupation_id: '0', rev_addrs1: '', rev_addrs2: '', rev_addrs3: '',
      rev_village: '', rev_mandal: '', rev_zilla_id: 0, pincode: '', vibhag_id: 0,
       zilla_id: 0, nagar_khanda_id: 0,mobile:"", upamandal_id: 0, basti_id: 0, 
       is_basti_gramam: '', basti_gramam_id: 0, 
       status: '', created_on: '', 
        added_occation:"",
        created_by: localStorage.getItem("log_member_id"), 
        modified_on: '', modified_by: localStorage.getItem("log_member_id"),
         desig_level_id: localStorage.getItem("desig_level_id") };

    // console.log("row", row);
    const initialValue = action === 'edit' ? JSON.parse(JSON.stringify(row)) : iValue;


    const designationlevelId = localStorage.getItem("desig_level_id");
    const designationbasedvallidation = parseInt(designationlevelId);
    const vibahgId = localStorage.getItem("vibhag_id");
    const zillId = localStorage.getItem("zill_id");
    const nagarkhandId = localStorage.getItem("nagar_khanda_id");
    const upamandabastiId = localStorage.getItem("upamandal_basti_id");

    // console.log("upamandabastiId", upamandabastiId);

    var jsonArray1 = upamandal;
    var jsonArray2 = basti;
    jsonArray1 = jsonArray1.concat(jsonArray2);

    const filteredVibhags = vibhag.filter((vibhag) => vibhag.vibhag_id === 8 || vibhag.vibhag_id === 9);



    const filterjillasonlogin = jillas.filter((jilla) => jilla.vibhag_id == parseInt(vibahgId));

    // console.log("samithifilterjillasonlogin", filterjillasonlogin)


    const filterkhandasonlogin = nagars.filter((nagar) => nagar.jilla_id == parseInt(zillId));

    const upamandalbastinagarkhand = upamandal.filter((upamandal_basti) => upamandal_basti.nagar_khanda_id == parseInt(nagarkhandId))

    const bastinagarkhand = basti.filter((upamandal_basti) => upamandal_basti.nagar_khanda_id == parseInt(nagarkhandId))

    // const upamandalbastinagarkhanffilter = nagars.filter((upamandal_basti) => upamandal_basti.nagar.nagar_khanda_id == parseInt(nagarkhandId))

    const upamandalbastinagarkhanffilter = nagars.filter((upamandal_basti) =>
        upamandal_basti.nagar.some((nagar) => nagar.nagar_khanda_id === parseInt(nagarkhandId) && nagar.nagar_khanda_type === 3)
    );


    const filtergramam = gramam.filter((upamandal_basti) => upamandal_basti.UpaMandalID == parseInt(upamandabastiId))



    const [purekhanda, setPureKhanda] = useState([]);
    const [pureNagar, setPureNagar] = useState([]);
    const [partiakhandanagar, setPartialkhandanagar] = useState([]);
    const [upamandalarray, setUpamandalarray] = useState([]);

    const [editgramam, seteditgramam] = useState(action === "edit" ? row.basti_gramam_id : "");
    const [editupamandal, seteditupamandal] = useState(action === "edit" ? row.upamandal_id : "");
    const [editbasti, seteditbasti] = useState(action === "edit" ? row.basti_id : "");

    const [isgramamavailable, setIsgramamavailable] = useState(action === "edit" && row.basti_gramam_id ? 'Yes':'');






    let nagar_khandaId=localStorage.getItem('nagar_khanda_id')
    let jilla_id=localStorage.getItem("jilla_id")
    // console.log("210nagar_khandaId",nagar_khandaId)
    let vibhag_id=localStorage.getItem("vibhag_id")
    let upamandal_basthi_id=localStorage.getItem("upamandal_basthi_id")
    console.log("213upamandal_basthi_id",upamandal_basthi_id)
    let vibhagName=localStorage.getItem('vibhag_name')
    let jillaName=localStorage.getItem('zilla_name')
    let nagarKhandaName=localStorage.getItem('nagar_khanda_name')
    let upMandalName=localStorage.getItem('upamandal_name')
    let gramamName = localStorage.getItem('gramam_name')
    // console.log("44upMandalNamegramamspage",upMandalName)
    let bastiName=localStorage.getItem('basti_name')
    let gramamId = localStorage.getItem('gramam_id')
    let BasthiId= localStorage.getItem("basthi_id")

    let gramamBasthiType = localStorage.getItem("basti_gramam_type")

    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            let iseditmode = false;
            if (action === 'edit') {
                iseditmode = true;
                // values.bhadyatha_id="3"
                // if (values.basti_id === null ){
                //     values.basti_id =0 
                // }
                if(values.zilla_id===null){
                let ZillaId = localStorage.getItem("zilla_id")
                    values.zilla_id=ZillaId
                }
            } else {
                iseditmode = false;
                console.log("values onsubmit ",values);
                values.vibhag_id=vibhag_id;
                values.zilla_id=jilla_id;
                // values.bhadyatha_id="3"
                values.added_occation="RAM"
                if(values.zilla_id===null){
                    let ZillaId = localStorage.getItem("zilla_id")
                        values.zilla_id=ZillaId
                    }
                values.nagar_khanda_id=nagar_khandaId;
                values.upamandal_id=localStorage.getItem("upamandal_basthi_id")
                if (values.basti_id === null ){
                    values.basti_id =0 
                }
                else if(gramamBasthiType=='basti'){
                values.basti_id=BasthiId;
                values.upamandal_id=0
            }else {
                values.basti_gramam_id=gramamId;
            }
    

            }
          

            delete values.desig_level_id
     

            const response = iseditmode ? await updateData(values) : await addSamithi_Members(values);

            if (response && (response.status === 200 || response.status === 201)) {

                if (iseditmode == true) {
                   // dispatch(setSamithi_MembersMessage("Updated Successfully"));
                    alert("Address has been updated successfully");
                } else {
                    console.log("response129",response)
                   let BasthiId= localStorage.getItem("basthi_id")
                   console.log("141BasthiId",BasthiId)
                   let gramamId= localStorage.getItem("gramam_id")
                   console.log("143gramamId",gramamId)
                  let gramamBasthiType = localStorage.getItem("basti_gramam_type")
                    //dispatch(setSamithi_MembersMessage("Added Successfully"));
                    alert("Address has been saved successfully");
                    if(gramamBasthiType ==="basti"){
                    navigate("/samithi_members/"+BasthiId)
                    }else if (gramamBasthiType ==="gramam") {
                        navigate("/samithi_members/"+gramamId)
                    }
                }
                hideShowForm(false);
            } else {
                alert("Something went wrong. Please contact administrator");
            }

        },
        validationSchema: yup.object({
            // rev_zilla_id: yup.number().required('Revenue District is Required'),
            name: yup.string().required('Name is Required'),
            mobile: yup.string().length(10, 'Mobile Number should have 10 digits').required('Mobile Number is required'). matches(/^[0-9]{10}$/, "Please enter valid Mobile Number"),
            rev_zilla_id:yup.number().moreThan(0, 'Revenue District is required')
                      }),
              
                  
    }
    );
console.log("215validationSChema",formik.errors)

    const handleCustomChange = (event) => {
    const oncahangekhand = nagars.flatMap((nagar) =>
            nagar.nagar.filter((nagar) => {
                return nagar.nagar_khanda_id == event.target.value && nagar.nagar_khanda_type == 1;
            })
        );

        const oncahngenagar = nagars.flatMap((nagar) =>
            nagar.nagar.filter((nagar) => {
                return nagar.nagar_khanda_id == event.target.value && nagar.nagar_khanda_type == 2;
            })

        );
        const oncahngenagarkhanda = nagars.flatMap((nagar) =>
            nagar.nagar.filter((nagar) => {
                return nagar.nagar_khanda_id == event.target.value && nagar.nagar_khanda_type == 3;
            })
        );
        //  JSON.parse(JSON.stringify(row.basti_gramam_id)) =0;
        // row.basti_gramam_id = 0;
        seteditgramam("");
        seteditupamandal("");
        seteditbasti("");
        setPureKhanda(oncahangekhand);
        setPureNagar(oncahngenagar);
        setPartialkhandanagar(oncahngenagarkhanda);

        if(oncahngenagar.length>0){
        upamandalarray.length=0;
        setPureKhanda([]);
        }

        console.log("4oncahngenagarkhanda", oncahngenagarkhanda)


        console.log("setPureKhanda", oncahangekhand);
        console.log("setPureNagar", oncahngenagar);
        console.log("setPartialkhandanagar", oncahngenagarkhanda);

        formik.handleChange(event);

    };

    const handleupamandalorbastiChange = (event) => {
        console.log("1");
        console.log("2",event.target.value);
        let selectedValue = event.target.value;
        const oncahangeupamandal = jsonArray1.flatMap((upamandal_basti) =>
            upamandal_basti.upamandal_bastis.filter(upamandal => {
                return upamandal.upamandal_basti_id == parseInt(event.target.value) && upamandal.is_gramam_available === "Yes"
            })
        );

        console.log("3oncahangeupamandal", oncahangeupamandal);
        setUpamandalarray(oncahangeupamandal);
        seteditgramam("");

        // console.log("oncahangeupamandal1", oncahangeupamandal.length);

        // console.log("oncahangeupamandal1", oncahangeupamandal[0]);

        // console.log("setUpamandal2", upamandalarray);

        formik.handleChange(event);

        if (oncahangeupamandal.length > 0) {

            // console.log("1");

            let is_available = oncahangeupamandal[0].is_gramam_available;

            setIsgramamavailable(is_available);
            // console.log("is_available1", is_available)

            formik.setFieldValue("upamandal_id", selectedValue);
            formik.setFieldValue("basti_id", 0);

            // formik.values.basti_id = 0;
            // console.log("261basthi_id=0",formik.values.basti_id)
        } else {
            // console.log("2");
            let is_available = "No";
            setIsgramamavailable(is_available);

            // console.log("is_available2", isgramamavailable)

            formik.setFieldValue("basti_id", selectedValue);
            formik.setFieldValue("upamandal_id", 0);
            formik.setFieldValue("basti_gramam_id", 0);


            // formik.values.upamandal_id = 0;
            // console.log("271upamandal_id=0",formik.values.upamandal_id)
            // console.log("272Basthi_id",selectedValue)

        }

    };
    const updateData = async (values) => {
        console.log("updatevalues", values);
        // values.desig_level_id = localStorage.getItem("desig_level_id");
        values.modified_by = localStorage.getItem("desig_level_id");

        // if (values.basti_id != "") {
        //     values.upamandal_id = 0;
        //     values.basti_gramam_id = 0;
        // } else {
        //      values.basti_id = 0;
        // }
        let updateValues = JSON.parse(JSON.stringify(values));
        delete updateValues.created_by
        delete updateValues.created_on
        delete updateValues.modified_on

        return await updateSamithi_Members(row.samithi_member_id, updateValues)

    }
 
    // console.log("44upbastiNamegramamspage",upMandalName)

let DesignationId=parseInt(localStorage.getItem("desig_level_id"))
    
    return (
        <>
        <nav aria-label="breadcrumb">   
           { DesignationId!=7 &&  
        <ol className="breadcrumb" >
          {DesignationId!= 6 &&
          <>
          {DesignationId!= 5 &&<>
          {DesignationId!= 4 && <>
          {DesignationId!= 3 && <>
          
                           <li className="breadcrumb-item" ><Link to="/vibhagreports" style={{color:"#194380"}}>{vibhagName}</Link></li></>}
                           {vibhag_id&&  <li className="breadcrumb-item" ><Link to={'/jillareports/'+vibhag_id} style={{color:"#194380"}}>{jillaName }</Link></li>}</>}
                            <li className="breadcrumb-item"><Link to={'/nagarkhandareports/'+jilla_id}  style={{color:"#194380"}}>{nagarKhandaName}</Link></li></>}
                            {upMandalName != "undefined"  && upMandalName && upMandalName !="null" &&
                            <li className="breadcrumb-item" ><Link to={"/upmandalbasthireports/"+nagar_khandaId}  style={{color:"#194380"}}>{upMandalName}</Link></li>
                              }  </>}
                              {gramamName !="null" && gramamName  != "undefined" && gramamName &&
                               <li className="breadcrumb-item" ><Link to={"/gramamreports/"+upamandal_basthi_id}  style={{color:"#194380"}}>{gramamName}</Link></li>
                              }
                               {bastiName != "undefined" && bastiName!="null" &&  
                            <li className="breadcrumb-item" ><Link to={"/upmandalbasthireports/"+nagar_khandaId}  style={{color:"#194380"}}>{bastiName}</Link></li>
                              }  
                        </ol>
}
                      </nav> 
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold  text-capitalize" style={{color:"#194380"}}>{action}  New Address -<span style={{color:'#fd803a'}}> {gramamName && gramamName.length>0 ? gramamName : (bastiName && bastiName.length>0 ? bastiName:"")}</span>
                    <ViewMembersButton className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50" style={{backgroundColor:"#194380"}}>
                            <i className="fas fa-list" style={{backgroundColor:"#194380" }}></i>
                        </span>
                        <span className="text" style={{backgroundColor:"#194380",borderColor:"#194380"}} >View Addresses</span>
                    </ViewMembersButton>
                </h6>
            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit} aria-disabled={isPreview}>
                {/* <Form.Group>
                        <label className="form -control-label" style={generalStyles}>బాధ్యత / Baadhyatha <span className="text-danger font-weight-bold"> </span></label>
                        <Form.Control
                            as="select"
                            name="bhadyatha_id"
                            value={formik.values.bhadyatha_id}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-control"
                        >
                            <option value="3">Member / సభ్యులు</option>
                          
                        </Form.Control>
               
                    </Form.Group> */}
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles} >పూర్తి పేరు ( ఇంటిపేరు తో సహా  ) / Full Name ( Including Surname) <span className="text-danger font-weight-bold"> *</span> </label>
                        <Form.Control type="text" name="name" className="form-control" value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.name && !!formik.errors.name}
                            isValid={!!formik.touched.name && !formik.errors.name}
                        ></Form.Control>
                        {
                            formik.errors.name && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.name}</>
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    {/* <Form.Group>
                        <label className="form -control-label" style={generalStyles}>ఇంటి పేరు / Surname <span className="text-danger font-weight-bold"> *</span></label>
                        <Form.Control type="text" name="surname" className="form-control" value={formik.values.surname}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.surname && !!formik.errors.surname}
                            isValid={!!formik.touched.surname && !formik.errors.surname}
                        ></Form.Control>
                        {
                            formik.errors.surname && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.surname}</>
                                </Form.Control.Feedback>
                            )}
                    </Form.Group> */}
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>తండ్రి పేరు / Father Name <span className="text-danger font-weight-bold"> </span></label>
                        <Form.Control type="text" name="father_name" className="form-control" value={formik.values.father_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // isInvalid={!!formik.touched.father_name && !!formik.errors.father_name}
                            // isValid={!!formik.touched.father_name && !formik.errors.father_name}
                        ></Form.Control>
                        {/* {
                            formik.errors.father_name && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.father_name}</>
                                </Form.Control.Feedback>
                            )} */}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>మొబైల్ నంబర్ / Mobile Number<span className="text-danger font-weight-bold"> *</span></label>
                        <Form.Control type="number" name="mobile" className="form-control" value={formik.values.mobile}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            inputMode="numeric"
                            isInvalid={!!formik.touched.mobile && !!formik.errors.mobile}
                            isValid={!!formik.touched.mobile && !formik.errors.mobile}
                        ></Form.Control>
                        {
                            formik.errors.mobile && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.mobile}</>
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>వయస్సు / Age<span className="text-danger font-weight-bold"></span></label>
                        <Form.Control type="number" name="age" className="form-control" value={formik.values.age}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            inputMode="numeric"
                            ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>వృత్తి / Occupation <span className="text-danger font-weight-bold"> </span></label>
                        <Form.Control
                            as="select"
                            name="occupation_id"
                            value={formik.values.occupation_id}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-control" >
                            <option value="">-- Select Occupation --</option>
                            {
                                occupation.map((occupation) => {
                                    return <option key={occupation.occupation_id} value={occupation.occupation_id}>{occupation.occupation_name}</option>
                                })}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>ఇంటి నంబరు / అపార్టుమెంటు పేరు, ఫ్లాట్ నంబరు - House No / Apartment Name, Flat No <span className="text-danger font-weight-bold"></span></label>
                        <Form.Control type="text" name="rev_addrs1" className="form-control" value={formik.values.rev_addrs1}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>వీధి పేరు / Street Name</label>
                        <Form.Control type="text" name="rev_addrs2" className="form-control" value={formik.values.rev_addrs2}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.rev_addrs2 && !!formik.errors.rev_addrs2}
                            isValid={!!formik.touched.rev_addrs2 && !formik.errors.rev_addrs2}
                        ></Form.Control>
                        {
                            formik.errors.rev_addrs2 && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.rev_addrs2}</>
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>మండల్ / Mandal</label>
                        <Form.Control type="text" name="rev_mandal" className="form-control" value={formik.values.rev_mandal}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={!!formik.touched.rev_mandal && !!formik.errors.rev_mandal}
                            isValid={!!formik.touched.rev_mandal && !formik.errors.rev_mandal}
                        ></Form.Control>
                        {
                            formik.errors.rev_mandal && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.rev_mandal}</>
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}> రెవెన్యూ జిల్లా / Revenue District <span className="text-danger font-weight-bold"> *</span></label>
                        <Form.Control
                            as="select"
                            name="rev_zilla_id"
                            value={formik.values.rev_zilla_id}
                            onChange={e => { formik.handleChange(e) }}
                            onBlur={formik.handleBlur}
                            className="form-control"
                            isInvalid={!!formik.touched.rev_zilla_id && !!formik.errors.rev_zilla_id}
                            isValid={!!formik.touched.rev_zilla_id && !formik.errors.rev_zilla_id}
>                        
                            <option value="">-- Select Revenue District --</option>
                            {
                                rev_zillas.map((distrcit) => {
                                    return <option key={distrcit.rev_zilla_id} value={distrcit.rev_zilla_id}>{distrcit.team_name}</option>
                                })}
                        </Form.Control>
                        {
                            formik.errors.rev_zilla_id && (
                                <Form.Control.Feedback type="invalid">
                                    <>{formik.errors.rev_zilla_id}</>
                                </Form.Control.Feedback>
                            )}
                    </Form.Group>
                    <Form.Group>
                        <label className="form -control-label" style={generalStyles}>పోస్టల్ పిన్ కోడ్ / Pincode<span className="text-danger font-weight-bold"> </span></label>
                        <Form.Control type="text" name="pincode" className="form-control" value={formik.values.pincode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        ></Form.Control>
                    </Form.Group>
                    {(
                        designationlevelId == '1' ||
                        designationlevelId == '2'

                    ) && vibhag_id.length< 0  &&
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>విభాగ్ / Vibhag <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control
                                as="select"
                                name="vibhag_id"
                                value={formik.values.vibhag_id}
                                onChange={e => {
                                    formik.values.zilla_id = 0
                                    formik.values.nagar_khanda_id = 0
                                    formik.values.upamandal_id = 0
                                    formik.handleChange(e)
                                }}
                                // onBlur={formik.handleBlur}
                                onBlur={() => {
                                    formik.setTouched({ firstSmoker: true });
                                }}

                                className="form-control"
                                isInvalid={!!formik.touched.vibhag_id && !!formik.errors.vibhag_id}
                                isValid={!!formik.touched.vibhag_id && !formik.errors.vibhag_id}>
                                <option value="">-- Select Vibhag --</option>
                                {
                                    designationlevelId == "2" && filteredVibhags && filteredVibhags.length > 0 ?

                                        filteredVibhags.map((level) => {
                                            return <option key={level.vibhag_id} value={level.vibhag_id}>{level.vibhag_name}</option>
                                        }) :
                                        vibhag.map((level) => {
                                            return <option key={level.vibhag_id} value={level.vibhag_id}>{level.vibhag_name}</option>
                                        })}

                            </Form.Control>
                            {
                                formik.errors.vibhag_id && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.vibhag_id}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                    }

                    {(
                        designationlevelId == '1' ||
                        designationlevelId == '2' ||
                        designationlevelId == '3'
                    ) && jilla_id.length <0  && 
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>జిల్లా / Jilla <span className="text-danger font-weight-bold"> *</span></label>
                            <Form.Control
                                as="select"
                                name="zilla_id"
                                value={formik.values.zilla_id}
                                onChange={e => {
                                    formik.values.nagar_khanda_id = 0
                                    formik.values.upamandal_id = 0

                                    formik.handleChange(e)
                                }}
                                onBlur={formik.handleBlur}

                                className="form-control"
                                isInvalid={!!formik.touched.zilla_id && !!formik.errors.zilla_id}
                                isValid={!!formik.touched.zilla_id && !formik.errors.zilla_id}>
                                <option value="">-- Select Jilla --</option>
                                {
                                    filterjillasonlogin && filterjillasonlogin.length > 0 ?
                                        filterjillasonlogin.map((jilla) => {
                                            return jilla.jillas.map(level => {
                                                return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                                            })
                                        }) :
                                        jillas.map((jilla) => {
                                            if (jilla.vibhag_id == formik.values.vibhag_id) {
                                                return jilla.jillas.map(level => {
                                                    return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                                                })
                                            }

                                        })}

                            </Form.Control>
                            {
                                formik.errors.zilla_id && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.zilla_id}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                    }

                    {(
                        designationlevelId == '1' ||
                        designationlevelId == '2' ||
                        designationlevelId == '3' ||
                        designationlevelId == '4'

                    ) && nagar_khandaId.length <0 && 
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>ఖండ/నగర్ - Khanda/Nagar</label>
                            <Form.Control
                                as="select"
                                name="nagar_khanda_id"
                                value={formik.values.nagar_khanda_id}
                                onChange={e => {
                                    formik.values.upamandal_id = 0
                                    formik.values.basti_gramam_id = 0
                                    formik.values.basti_id = 0
                                    
                                    handleCustomChange(e)
                                }}
                                onBlur={formik.handleBlur}
                                className="form-control"
                                isInvalid={!!formik.touched.nagar_khanda_id && !!formik.errors.nagar_khanda_id}
                                isValid={!!formik.touched.nagar_khanda_id && !formik.errors.nagar_khanda_id}
                            >
                                <option value="">-- Select Khanda/Nagar --</option>
                                {
                                    filterkhandasonlogin && filterkhandasonlogin.length > 0 ?
                                        filterkhandasonlogin.map((nagar) => {
                                            return nagar.nagar.map(level => {
                                                return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                                            })
                                        }) :
                                        nagars.map((nagar) => {
                                            if (nagar.jilla_id == formik.values.zilla_id) {
                                                return nagar.nagar.map(level => {
                                                    return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}--{level.nagar_khanda_type}</option>
                                                })
                                            }

                                        })
                                }

                            </Form.Control>
                            {
                                formik.errors.nagar_khanda_id && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.nagar_khanda_id}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                    }

                    {purekhanda && purekhanda.length > 0 ? (
                        designationlevelId == '1' ||
                        designationlevelId == '2' ||
                        designationlevelId == '3' ||
                        designationlevelId == '4' ||
                        designationlevelId == '5'
                    ) && upamandal_basthi_id.length <0 && 
                        <Form.Group>
                            <label className="form -control-label" style={generalStyles}>ఉపమండలం - Upamandal</label>
                            <Form.Control
                                as="select"
                                name="upamandal_id"
                                value={formik.values.upamandal_id}
                                onChange={
                                    (e) => handleupamandalorbastiChange(e)}
                                onBlur={formik.handleBlur}
                                className="form-control"
                                isInvalid={!!formik.touched.upamandal_id && !!formik.errors.upamandal_id}
                                isValid={!!formik.touched.upamandal_id && !formik.errors.upamandal_id}
                            >
                                <option value="">-- Select Upamandal --</option>

                                {
                                    upamandalbastinagarkhand && upamandalbastinagarkhand.length > 0 ?
                                        upamandalbastinagarkhand.map((upamandal_basti) => {
                                            return upamandal_basti.upamandal_bastis.map(level => {
                                                return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}</option>
                                            })
                                        })
                                        :
                                        bastinagarkhand && bastinagarkhand.length > 0 ?
                                            bastinagarkhand.map((upamandal_basti) => {
                                                return upamandal_basti.upamandal_bastis.map(level => {
                                                    return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}</option>
                                                })
                                            })
                                            :


                                            jsonArray1.map((upamandal_basti) => {
                                                if (upamandal_basti.nagar_khanda_id == formik.values.nagar_khanda_id) {
                                                    return upamandal_basti.upamandal_bastis.map(level => {
                                                        return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}</option>

                                                    })

                                                }
                                            })


                                }

                            </Form.Control>
                            {
                                formik.errors.upamandal_id && (
                                    <Form.Control.Feedback type="invalid">
                                        <>{formik.errors.upamandal_id}</>
                                    </Form.Control.Feedback>
                                )}
                        </Form.Group>
                        : ""}
   <Form.Group>
                        <Button type="submit" className="float-right" variant="primary" style={{backgroundColor:"#194380"}}>Save</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
        </>
    );
}
